import React, { useState } from "react";

export default function JobSearch({ onSearch }) {
  const [values, setValues] = useState({ keyword: "", location: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(values);
  };

  return (
    <form className="sf-job-search" onSubmit={handleSubmit}>
      <div className="sf-search-field">
        <i className="ri-search-line" />
        <input
          type="text"
          placeholder="Search by"
          value={values.keyword}
          onChange={(e) => setValues({ ...values, keyword: e.target.value })}
        />
      </div>
      <div className="sf-search-field">
        <i className="ri-map-pin-line" />
        <input
          type="text"
          placeholder="Province or City"
          value={values.location}
          onChange={(e) => setValues({ ...values, location: e.target.value })}
        />
      </div>
      <button type="submit" className="sf-search-btn">
        Find Jobs
      </button>
    </form>
  );
}
